/* eslint-disable */ var AggregationType;
(function(AggregationType) {
    AggregationType["COUNT"] = "COUNT";
    AggregationType["COUNT_SAMPLES"] = "COUNT_SAMPLES";
    AggregationType["HISTOGRAM"] = "HISTOGRAM";
    AggregationType["LAST"] = "LAST";
    AggregationType["MAX"] = "MAX";
    AggregationType["MEAN"] = "MEAN";
    AggregationType["MEDIAN"] = "MEDIAN";
    AggregationType["MIN"] = "MIN";
    AggregationType["P10"] = "P10";
    AggregationType["P20"] = "P20";
    AggregationType["P25"] = "P25";
    AggregationType["P30"] = "P30";
    AggregationType["P40"] = "P40";
    AggregationType["P50"] = "P50";
    AggregationType["P60"] = "P60";
    AggregationType["P70"] = "P70";
    AggregationType["P75"] = "P75";
    AggregationType["P80"] = "P80";
    AggregationType["P90"] = "P90";
    AggregationType["P95"] = "P95";
    AggregationType["P99"] = "P99";
    AggregationType["P999"] = "P999";
    AggregationType["P9999"] = "P9999";
    AggregationType["STDEV"] = "STDEV";
    AggregationType["SUM"] = "SUM";
    AggregationType["SUMSQ"] = "SUMSQ";
    AggregationType["TYPE_INVALID"] = "TYPE_INVALID";
})(AggregationType || (AggregationType = {}));
var AlertEventType;
(function(AlertEventType) {
    AlertEventType["MONITOR_MUTED"] = "MONITOR_MUTED";
    AlertEventType["MONITOR_RESOLVED"] = "MONITOR_RESOLVED";
    AlertEventType["MONITOR_RESOLVED_NOTIFICATION_FAILED_TO_SEND"] = "MONITOR_RESOLVED_NOTIFICATION_FAILED_TO_SEND";
    AlertEventType["MONITOR_RESOLVED_NOTIFICATION_SENT"] = "MONITOR_RESOLVED_NOTIFICATION_SENT";
    AlertEventType["MONITOR_TRIGGERED"] = "MONITOR_TRIGGERED";
    AlertEventType["MONITOR_TRIGGERED_NOTIFICATION_FAILED_TO_SEND"] = "MONITOR_TRIGGERED_NOTIFICATION_FAILED_TO_SEND";
    AlertEventType["MONITOR_TRIGGERED_NOTIFICATION_SENT"] = "MONITOR_TRIGGERED_NOTIFICATION_SENT";
    AlertEventType["MONITOR_UNMUTED"] = "MONITOR_UNMUTED";
    AlertEventType["UNKNOWN"] = "UNKNOWN";
})(AlertEventType || (AlertEventType = {}));
var AlertRouteMatcherType;
(function(AlertRouteMatcherType) {
    AlertRouteMatcherType["EXACT_MATCHER_TYPE"] = "EXACT_MATCHER_TYPE";
    AlertRouteMatcherType["REGEXP_MATCHER_TYPE"] = "REGEXP_MATCHER_TYPE";
})(AlertRouteMatcherType || (AlertRouteMatcherType = {}));
var AlertState;
(function(AlertState) {
    AlertState["CRITICAL"] = "CRITICAL";
    AlertState["DOWNTIMED"] = "DOWNTIMED";
    AlertState["FIRING"] = "FIRING";
    AlertState["INACTIVE"] = "INACTIVE";
    AlertState["PASS"] = "PASS";
    AlertState["PENDING"] = "PENDING";
    AlertState["UNKNOWN"] = "UNKNOWN";
    AlertState["WARNING"] = "WARNING";
})(AlertState || (AlertState = {}));
var CollectionLinkType;
(function(CollectionLinkType) {
    CollectionLinkType["DASHBOARD"] = "DASHBOARD";
    CollectionLinkType["MONITOR"] = "MONITOR";
})(CollectionLinkType || (CollectionLinkType = {}));
var CollectionType;
(function(CollectionType) {
    CollectionType["SERVICE"] = "SERVICE";
    CollectionType["SIMPLE"] = "SIMPLE";
})(CollectionType || (CollectionType = {}));
var ComponentDiscoveryOverrideStatus;
(function(ComponentDiscoveryOverrideStatus) {
    ComponentDiscoveryOverrideStatus["DISABLED"] = "DISABLED";
    ComponentDiscoveryOverrideStatus["ENABLED"] = "ENABLED";
})(ComponentDiscoveryOverrideStatus || (ComponentDiscoveryOverrideStatus = {}));
var ComponentPresentationOverrideStatus;
(function(ComponentPresentationOverrideStatus) {
    ComponentPresentationOverrideStatus["DISABLED"] = "DISABLED";
    ComponentPresentationOverrideStatus["ENABLED"] = "ENABLED";
})(ComponentPresentationOverrideStatus || (ComponentPresentationOverrideStatus = {}));
var ComponentPresentationType;
(function(ComponentPresentationType) {
    ComponentPresentationType["EVENTS"] = "EVENTS";
    ComponentPresentationType["PANELS"] = "PANELS";
    ComponentPresentationType["UNKNOWN"] = "UNKNOWN";
})(ComponentPresentationType || (ComponentPresentationType = {}));
var ComponentType;
(function(ComponentType) {
    ComponentType["COMPUTE"] = "COMPUTE";
    ComponentType["RPC"] = "RPC";
    ComponentType["UNKNOWN"] = "UNKNOWN";
})(ComponentType || (ComponentType = {}));
var ConditionLevel;
(function(ConditionLevel) {
    ConditionLevel["CRITICAL"] = "CRITICAL";
    ConditionLevel["UNKNOWN"] = "UNKNOWN";
    ConditionLevel["WARN"] = "WARN";
})(ConditionLevel || (ConditionLevel = {}));
var DatasetType;
(function(DatasetType) {
    DatasetType["DATASET_TYPE_INVALID"] = "DATASET_TYPE_INVALID";
    DatasetType["TRACES"] = "TRACES";
})(DatasetType || (DatasetType = {}));
var DatasourceType;
(function(DatasourceType) {
    DatasourceType["GRAPHITE"] = "GRAPHITE";
    DatasourceType["LOGGING"] = "LOGGING";
    DatasourceType["PROMETHEUS"] = "PROMETHEUS";
})(DatasourceType || (DatasourceType = {}));
var DiscoveryStatus;
(function(DiscoveryStatus) {
    DiscoveryStatus["Added"] = "Added";
    DiscoveryStatus["Deleted"] = "Deleted";
    DiscoveryStatus["Modified"] = "Modified";
    DiscoveryStatus["Unchanged"] = "Unchanged";
    DiscoveryStatus["Unknown"] = "Unknown";
})(DiscoveryStatus || (DiscoveryStatus = {}));
var DropRuleMode;
(function(DropRuleMode) {
    DropRuleMode["DISABLED"] = "DISABLED";
    DropRuleMode["ENABLED"] = "ENABLED";
})(DropRuleMode || (DropRuleMode = {}));
var EditSource;
(function(EditSource) {
    EditSource["EDITABLE"] = "EDITABLE";
    EditSource["UNEDITABLE_K8S_OWNED"] = "UNEDITABLE_K8S_OWNED";
    EditSource["UNEDITABLE_SLO_GENERATED"] = "UNEDITABLE_SLO_GENERATED";
    EditSource["UNEDITABLE_TF_OWNED"] = "UNEDITABLE_TF_OWNED";
})(EditSource || (EditSource = {}));
var EntityVersionOrder;
(function(EntityVersionOrder) {
    EntityVersionOrder["ASC"] = "ASC";
    EntityVersionOrder["DESC"] = "DESC";
})(EntityVersionOrder || (EntityVersionOrder = {}));
var EntityVersionSource;
(function(EntityVersionSource) {
    EntityVersionSource["API"] = "API";
    EntityVersionSource["CHRONOCTL"] = "CHRONOCTL";
    EntityVersionSource["TERRAFORM"] = "TERRAFORM";
    EntityVersionSource["UI"] = "UI";
    EntityVersionSource["UNKNOWN"] = "UNKNOWN";
})(EntityVersionSource || (EntityVersionSource = {}));
var EntityVersionType;
(function(EntityVersionType) {
    EntityVersionType["DASHBOARD"] = "DASHBOARD";
    EntityVersionType["MONITOR"] = "MONITOR";
})(EntityVersionType || (EntityVersionType = {}));
var ExportFormat;
(function(ExportFormat) {
    ExportFormat["CHRONOCTL"] = "CHRONOCTL";
    ExportFormat["TERRAFORM"] = "TERRAFORM";
    ExportFormat["UNKNOWN"] = "UNKNOWN";
})(ExportFormat || (ExportFormat = {}));
var FavoriteEntityType;
(function(FavoriteEntityType) {
    FavoriteEntityType["DASHBOARD"] = "DASHBOARD";
    FavoriteEntityType["GRAFANA_DASHBOARD"] = "GRAFANA_DASHBOARD";
    FavoriteEntityType["MONITOR"] = "MONITOR";
})(FavoriteEntityType || (FavoriteEntityType = {}));
var FeatureFlagType;
(function(FeatureFlagType) {
    FeatureFlagType["BOOL"] = "BOOL";
    FeatureFlagType["INT"] = "INT";
    FeatureFlagType["STRING"] = "STRING";
})(FeatureFlagType || (FeatureFlagType = {}));
var LabelMatcherType;
(function(LabelMatcherType) {
    LabelMatcherType["EXACT_MATCHER_TYPE"] = "EXACT_MATCHER_TYPE";
    LabelMatcherType["NOT_EXACT_MATCHER_TYPE"] = "NOT_EXACT_MATCHER_TYPE";
    LabelMatcherType["NOT_REGEXP_MATCHER_TYPE"] = "NOT_REGEXP_MATCHER_TYPE";
    LabelMatcherType["REGEXP_MATCHER_TYPE"] = "REGEXP_MATCHER_TYPE";
})(LabelMatcherType || (LabelMatcherType = {}));
var ManagedBySource;
(function(ManagedBySource) {
    ManagedBySource["CHRONOCTL"] = "CHRONOCTL";
    ManagedBySource["CHRONOSPHERE"] = "CHRONOSPHERE";
    ManagedBySource["KUBERNETES"] = "KUBERNETES";
    ManagedBySource["SYNC_PROMETHEUS"] = "SYNC_PROMETHEUS";
    ManagedBySource["TERRAFORM"] = "TERRAFORM";
    ManagedBySource["UI"] = "UI";
    ManagedBySource["UNKNOWN"] = "UNKNOWN";
})(ManagedBySource || (ManagedBySource = {}));
var ManagedByType;
(function(ManagedByType) {
    ManagedByType["CHRONOSPHERE"] = "CHRONOSPHERE";
    ManagedByType["TENANT"] = "TENANT";
    ManagedByType["UNKNOWN"] = "UNKNOWN";
})(ManagedByType || (ManagedByType = {}));
var MappingRuleMode;
(function(MappingRuleMode) {
    MappingRuleMode["ENABLED"] = "ENABLED";
    MappingRuleMode["PREVIEW"] = "PREVIEW";
})(MappingRuleMode || (MappingRuleMode = {}));
var Match;
(function(Match) {
    Match["INVALID"] = "INVALID";
    Match["RULE"] = "RULE";
})(Match || (Match = {}));
var MetricType;
(function(MetricType) {
    MetricType["COUNTER"] = "COUNTER";
    MetricType["CUMULATIVE_COUNTER"] = "CUMULATIVE_COUNTER";
    MetricType["CUMULATIVE_EXPONENTIAL_HISTOGRAM"] = "CUMULATIVE_EXPONENTIAL_HISTOGRAM";
    MetricType["DELTA"] = "DELTA";
    MetricType["DELTA_COUNTER"] = "DELTA_COUNTER";
    MetricType["DELTA_EXPONENTIAL_HISTOGRAM"] = "DELTA_EXPONENTIAL_HISTOGRAM";
    MetricType["DISTRIBUTION"] = "DISTRIBUTION";
    MetricType["GAUGE"] = "GAUGE";
    MetricType["MEASUREMENT"] = "MEASUREMENT";
    MetricType["METRIC_TYPE_INVALID"] = "METRIC_TYPE_INVALID";
})(MetricType || (MetricType = {}));
var MutingRuleColumn;
(function(MutingRuleColumn) {
    MutingRuleColumn["ENDS_AT"] = "ENDS_AT";
    MutingRuleColumn["STARTS_AT"] = "STARTS_AT";
})(MutingRuleColumn || (MutingRuleColumn = {}));
var MutingRuleState;
(function(MutingRuleState) {
    MutingRuleState["ACTIVE"] = "ACTIVE";
    MutingRuleState["EXPIRED"] = "EXPIRED";
    MutingRuleState["PENDING"] = "PENDING";
})(MutingRuleState || (MutingRuleState = {}));
var NumericFilterComparisonType;
(function(NumericFilterComparisonType) {
    NumericFilterComparisonType["EQUAL"] = "EQUAL";
    NumericFilterComparisonType["GREATER_THAN"] = "GREATER_THAN";
    NumericFilterComparisonType["GREATER_THAN_OR_EQUAL"] = "GREATER_THAN_OR_EQUAL";
    NumericFilterComparisonType["LESS_THAN"] = "LESS_THAN";
    NumericFilterComparisonType["LESS_THAN_OR_EQUAL"] = "LESS_THAN_OR_EQUAL";
    NumericFilterComparisonType["NOT_EQUAL"] = "NOT_EQUAL";
    NumericFilterComparisonType["UNKNOWN"] = "UNKNOWN";
})(NumericFilterComparisonType || (NumericFilterComparisonType = {}));
var ObjectMergeRuleAction;
(function(ObjectMergeRuleAction) {
    ObjectMergeRuleAction["DROP"] = "DROP";
    ObjectMergeRuleAction["KEEP"] = "KEEP";
    ObjectMergeRuleAction["REPLACE_KEY"] = "REPLACE_KEY";
    ObjectMergeRuleAction["SUPPRESS"] = "SUPPRESS";
    ObjectMergeRuleAction["UNKNOWN"] = "UNKNOWN";
})(ObjectMergeRuleAction || (ObjectMergeRuleAction = {}));
var ObjectMergeRuleStatus;
(function(ObjectMergeRuleStatus) {
    ObjectMergeRuleStatus["DISABLED"] = "DISABLED";
    ObjectMergeRuleStatus["ENABLED"] = "ENABLED";
})(ObjectMergeRuleStatus || (ObjectMergeRuleStatus = {}));
var Ordering;
(function(Ordering) {
    Ordering["ASC"] = "ASC";
    Ordering["DESC"] = "DESC";
})(Ordering || (Ordering = {}));
var PermissionAction;
(function(PermissionAction) {
    PermissionAction["READ"] = "READ";
    PermissionAction["READWRITE"] = "READWRITE";
    PermissionAction["UNKNOWN"] = "UNKNOWN";
    PermissionAction["WRITE"] = "WRITE";
})(PermissionAction || (PermissionAction = {}));
var ResourcePoolLicense;
(function(ResourcePoolLicense) {
    ResourcePoolLicense["LICENSE_INVALID"] = "LICENSE_INVALID";
    ResourcePoolLicense["MATCHED_WRITES_HISTOGRAM"] = "MATCHED_WRITES_HISTOGRAM";
    ResourcePoolLicense["MATCHED_WRITES_STANDARD"] = "MATCHED_WRITES_STANDARD";
    ResourcePoolLicense["PERSISTED_WRITES_HISTOGRAM"] = "PERSISTED_WRITES_HISTOGRAM";
    ResourcePoolLicense["PERSISTED_WRITES_STANDARD"] = "PERSISTED_WRITES_STANDARD";
})(ResourcePoolLicense || (ResourcePoolLicense = {}));
var ResponderType;
(function(ResponderType) {
    ResponderType["ID"] = "ID";
    ResponderType["NAME"] = "NAME";
    ResponderType["UNKNOWN"] = "UNKNOWN";
    ResponderType["USERNAME"] = "USERNAME";
})(ResponderType || (ResponderType = {}));
var ResponseType;
(function(ResponseType) {
    ResponseType["ESCALATION"] = "ESCALATION";
    ResponseType["SCHEDULE"] = "SCHEDULE";
    ResponseType["TEAM"] = "TEAM";
    ResponseType["UNKNOWN"] = "UNKNOWN";
    ResponseType["USER"] = "USER";
})(ResponseType || (ResponseType = {}));
var RollupRuleMode;
(function(RollupRuleMode) {
    RollupRuleMode["ENABLED"] = "ENABLED";
    RollupRuleMode["PREVIEW"] = "PREVIEW";
})(RollupRuleMode || (RollupRuleMode = {}));
var RuleEvaluationErrorCode;
(function(RuleEvaluationErrorCode) {
    RuleEvaluationErrorCode["CONFLICTING_MONITOR_LABELS"] = "CONFLICTING_MONITOR_LABELS";
    RuleEvaluationErrorCode["CONFLICTING_RECORDING_LABELS"] = "CONFLICTING_RECORDING_LABELS";
    RuleEvaluationErrorCode["DUPLICATE_SERIES"] = "DUPLICATE_SERIES";
    RuleEvaluationErrorCode["INTERNAL"] = "INTERNAL";
    RuleEvaluationErrorCode["INVALID"] = "INVALID";
    RuleEvaluationErrorCode["LICENSE_EXCEEDED"] = "LICENSE_EXCEEDED";
    RuleEvaluationErrorCode["RESOURCE_EXHAUSTED"] = "RESOURCE_EXHAUSTED";
    RuleEvaluationErrorCode["TEMPLATE"] = "TEMPLATE";
    RuleEvaluationErrorCode["TIMEOUT"] = "TIMEOUT";
})(RuleEvaluationErrorCode || (RuleEvaluationErrorCode = {}));
var RuleEvaluationRuleType;
(function(RuleEvaluationRuleType) {
    RuleEvaluationRuleType["ALERTING"] = "ALERTING";
    RuleEvaluationRuleType["INVALID"] = "INVALID";
    RuleEvaluationRuleType["RECORDING"] = "RECORDING";
})(RuleEvaluationRuleType || (RuleEvaluationRuleType = {}));
var RuleEvaluationWindow;
(function(RuleEvaluationWindow) {
    RuleEvaluationWindow["INVALID"] = "INVALID";
    RuleEvaluationWindow["WINDOW_5M"] = "WINDOW_5M";
    RuleEvaluationWindow["WINDOW_30M"] = "WINDOW_30M";
})(RuleEvaluationWindow || (RuleEvaluationWindow = {}));
var SLOType;
(function(SLOType) {
    SLOType["ENDPOINT_AVAILABILITY"] = "ENDPOINT_AVAILABILITY";
    SLOType["LATENCY"] = "LATENCY";
})(SLOType || (SLOType = {}));
var SavedTraceSearchColumn;
(function(SavedTraceSearchColumn) {
    SavedTraceSearchColumn["CREATED_AT"] = "CREATED_AT";
    SavedTraceSearchColumn["NAME"] = "NAME";
})(SavedTraceSearchColumn || (SavedTraceSearchColumn = {}));
var SearchType;
(function(SearchType) {
    SearchType["INVALID"] = "INVALID";
    SearchType["LOGGING"] = "LOGGING";
    SearchType["TIMELINE"] = "TIMELINE";
})(SearchType || (SearchType = {}));
var SpanFilterMatchType;
(function(SpanFilterMatchType) {
    SpanFilterMatchType["EXCLUDE"] = "EXCLUDE";
    SpanFilterMatchType["INCLUDE"] = "INCLUDE";
    SpanFilterMatchType["UNKNOWN"] = "UNKNOWN";
})(SpanFilterMatchType || (SpanFilterMatchType = {}));
var StringFilterMatchType;
(function(StringFilterMatchType) {
    StringFilterMatchType["EXACT"] = "EXACT";
    StringFilterMatchType["EXACT_NEGATION"] = "EXACT_NEGATION";
    StringFilterMatchType["IN"] = "IN";
    StringFilterMatchType["NOT_IN"] = "NOT_IN";
    StringFilterMatchType["REGEX"] = "REGEX";
    StringFilterMatchType["REGEX_NEGATION"] = "REGEX_NEGATION";
    StringFilterMatchType["UNKNOWN"] = "UNKNOWN";
})(StringFilterMatchType || (StringFilterMatchType = {}));
var ThresholdOp;
(function(ThresholdOp) {
    ThresholdOp["EQ"] = "EQ";
    ThresholdOp["EXISTS"] = "EXISTS";
    ThresholdOp["GEQ"] = "GEQ";
    ThresholdOp["GT"] = "GT";
    ThresholdOp["INVALID"] = "INVALID";
    ThresholdOp["LEQ"] = "LEQ";
    ThresholdOp["LT"] = "LT";
    ThresholdOp["NEQ"] = "NEQ";
    ThresholdOp["NOT_EXISTS"] = "NOT_EXISTS";
})(ThresholdOp || (ThresholdOp = {}));
var TraceAggregationGroupByType;
(function(TraceAggregationGroupByType) {
    TraceAggregationGroupByType["OP"] = "OP";
    TraceAggregationGroupByType["SVC"] = "SVC";
    TraceAggregationGroupByType["TAG"] = "TAG";
    TraceAggregationGroupByType["UNKNOWN"] = "UNKNOWN";
})(TraceAggregationGroupByType || (TraceAggregationGroupByType = {}));
var TraceBehaviorAssignmentType;
(function(TraceBehaviorAssignmentType) {
    TraceBehaviorAssignmentType["MAIN"] = "MAIN";
    TraceBehaviorAssignmentType["OVERRIDE"] = "OVERRIDE";
    TraceBehaviorAssignmentType["REMOVED"] = "REMOVED";
    TraceBehaviorAssignmentType["UNKNOWN"] = "UNKNOWN";
})(TraceBehaviorAssignmentType || (TraceBehaviorAssignmentType = {}));
var TraceBehaviorSamplingType;
(function(TraceBehaviorSamplingType) {
    TraceBehaviorSamplingType["HIGH_VALUE"] = "HIGH_VALUE";
    TraceBehaviorSamplingType["LOW_VALUE"] = "LOW_VALUE";
    TraceBehaviorSamplingType["UNKNOWN"] = "UNKNOWN";
})(TraceBehaviorSamplingType || (TraceBehaviorSamplingType = {}));
var TraceBehaviorType;
(function(TraceBehaviorType) {
    TraceBehaviorType["BASELINE"] = "BASELINE";
    TraceBehaviorType["DEPRECATED"] = "DEPRECATED";
    TraceBehaviorType["DROP_ALL"] = "DROP_ALL";
    TraceBehaviorType["KEEP_ALL"] = "KEEP_ALL";
    TraceBehaviorType["UNKNOWN"] = "UNKNOWN";
})(TraceBehaviorType || (TraceBehaviorType = {}));
var TraceMetricsGroupByKeyType;
(function(TraceMetricsGroupByKeyType) {
    TraceMetricsGroupByKeyType["OPERATION"] = "OPERATION";
    TraceMetricsGroupByKeyType["SERVICE"] = "SERVICE";
    TraceMetricsGroupByKeyType["TAG"] = "TAG";
    TraceMetricsGroupByKeyType["UNKNOWN"] = "UNKNOWN";
})(TraceMetricsGroupByKeyType || (TraceMetricsGroupByKeyType = {}));
var UITheme;
(function(UITheme) {
    UITheme["DARK"] = "DARK";
    UITheme["LIGHT"] = "LIGHT";
    UITheme["SYSTEM"] = "SYSTEM";
    UITheme["UNKNOWN"] = "UNKNOWN";
})(UITheme || (UITheme = {}));
var UserState;
(function(UserState) {
    UserState["ACTIVE"] = "ACTIVE";
    UserState["DEACTIVATED"] = "DEACTIVATED";
    UserState["INVITED"] = "INVITED";
    UserState["PENDING"] = "PENDING";
    UserState["SYNCED"] = "SYNCED";
    UserState["UNKNOWN"] = "UNKNOWN";
})(UserState || (UserState = {}));
var UserType;
(function(UserType) {
    UserType["ACCOUNT"] = "ACCOUNT";
    UserType["SERVICE_ACCOUNT"] = "SERVICE_ACCOUNT";
    UserType["UNKNOWN"] = "UNKNOWN";
})(UserType || (UserType = {}));
var ValidationStatus;
(function(ValidationStatus) {
    ValidationStatus["INVALID"] = "INVALID";
    ValidationStatus["UNKNOWN"] = "UNKNOWN";
    ValidationStatus["VALID"] = "VALID";
})(ValidationStatus || (ValidationStatus = {}));
const GetFeatureFlagsV2Document = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: {
                kind: 'Name',
                value: 'GetFeatureFlagsV2'
            },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: {
                            kind: 'Name',
                            value: 'flags'
                        }
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'ListType',
                            type: {
                                kind: 'NonNullType',
                                type: {
                                    kind: 'NamedType',
                                    name: {
                                        kind: 'Name',
                                        value: 'FeatureFlagRequest'
                                    }
                                }
                            }
                        }
                    }
                }
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: {
                            kind: 'Name',
                            value: 'featureFlagsV2'
                        },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: {
                                    kind: 'Name',
                                    value: 'flags'
                                },
                                value: {
                                    kind: 'Variable',
                                    name: {
                                        kind: 'Name',
                                        value: 'flags'
                                    }
                                }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'key'
                                    }
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'value'
                                    },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'InlineFragment',
                                                typeCondition: {
                                                    kind: 'NamedType',
                                                    name: {
                                                        kind: 'Name',
                                                        value: 'BoolValue'
                                                    }
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            alias: {
                                                                kind: 'Name',
                                                                value: 'boolValue'
                                                            },
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'value'
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: 'InlineFragment',
                                                typeCondition: {
                                                    kind: 'NamedType',
                                                    name: {
                                                        kind: 'Name',
                                                        value: 'StringValue'
                                                    }
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            alias: {
                                                                kind: 'Name',
                                                                value: 'stringValue'
                                                            },
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'value'
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: 'InlineFragment',
                                                typeCondition: {
                                                    kind: 'NamedType',
                                                    name: {
                                                        kind: 'Name',
                                                        value: 'IntValue'
                                                    }
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            alias: {
                                                                kind: 'Name',
                                                                value: 'intValue'
                                                            },
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'value'
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const GetGatewayConfigsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: {
                kind: 'Name',
                value: 'GetGatewayConfigs'
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: {
                            kind: 'Name',
                            value: 'gatewayConfigs'
                        },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'returnedSeriesLimit'
                                    }
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'returnedDatapointsLimit'
                                    }
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'tracingUIEnabled'
                                    }
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'collectionsAccess'
                                    }
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'serviceUIEnabled'
                                    }
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'enableExternalServiceConfig'
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: {
                            kind: 'Name',
                            value: 'tenant'
                        },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'tenantConfiguration'
                                    },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'scrapeInterval'
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const GetCurrentUserContext = {
    additionalTypenames: []
};
const GetFeatureFlagsV2Context = {
    additionalTypenames: [
        'FeatureFlag'
    ]
};
const GetGatewayConfigsContext = {
    additionalTypenames: []
};

export { AggregationType, AlertEventType, AlertRouteMatcherType, AlertState, CollectionLinkType, CollectionType, ComponentDiscoveryOverrideStatus, ComponentPresentationOverrideStatus, ComponentPresentationType, ComponentType, ConditionLevel, DatasetType, DatasourceType, DiscoveryStatus, DropRuleMode, EditSource, EntityVersionOrder, EntityVersionSource, EntityVersionType, ExportFormat, FavoriteEntityType, FeatureFlagType, GetCurrentUserContext, GetFeatureFlagsV2Context, GetFeatureFlagsV2Document, GetGatewayConfigsContext, GetGatewayConfigsDocument, LabelMatcherType, ManagedBySource, ManagedByType, MappingRuleMode, Match, MetricType, MutingRuleColumn, MutingRuleState, NumericFilterComparisonType, ObjectMergeRuleAction, ObjectMergeRuleStatus, Ordering, PermissionAction, ResourcePoolLicense, ResponderType, ResponseType, RollupRuleMode, RuleEvaluationErrorCode, RuleEvaluationRuleType, RuleEvaluationWindow, SLOType, SavedTraceSearchColumn, SearchType, SpanFilterMatchType, StringFilterMatchType, ThresholdOp, TraceAggregationGroupByType, TraceBehaviorAssignmentType, TraceBehaviorSamplingType, TraceBehaviorType, TraceMetricsGroupByKeyType, UITheme, UserState, UserType, ValidationStatus };
//# sourceMappingURL=graphql.js.map
